export type TourHighlight = {
  name: string;
  description: string;
};

export type FAQ = {
  question: string;
  answer: string;
};

export const tourHighlights: TourHighlight[] = [
  {
    name: "Ned, the Brooklyn Bridge Cat",
    description:
      "Before the first pedestrians ever crossed the Brooklyn Bridge, one fearless stray cat beat them to it—becoming a tabloid hero and the bridge’s first unofficial mascot.",
  },
  {
    name: "Old Tom, the City Hall Mouser",
    description:
      "This savvy street cat didn't just lounge in City Hall—he ran it. With a personality as big as the city itself, Old Tom became a fixture of NYC politics and charmed his way into the history books.",
  },
  {
    name: "Smoke, the Firehouse Legend",
    description:
      "Part guard, part pest control, and all heart—Smoke was more than a firehouse cat. He was a four-pawed firefighter whose bravery earned him a permanent place in downtown Manhattan lore.",
  },
  {
    name: "Minnie of the Hotel St. George",
    description:
      "Known for her elegance and astonishing brood of 160 kittens, Minnie held court in one of Brooklyn's grandest hotels, greeting guests and staff like true royalty.",
  },
  {
    name: "The Post Office Cats",
    description:
      "Long before email, New York’s post offices relied on a stealthy feline workforce to keep the mail moving. These unsung heroes of the USPS fought the war on rats—and won.",
  },
  {
    name: "The Promenade Cat of Brooklyn Heights",
    description:
      "When one local cat refused to give up its perch, it sparked a movement. Learn how a neighborhood feline helped inspire one of the city’s most beloved scenic walkways.",
  },
];

export const faqs: FAQ[] = [
  {
    question: "What makes Cats About Town walking tours unique?",
    answer:
      "We tell the untold stories of New York’s most overlooked residents—cats. These aren’t your average city tours; they’re deep dives into the city’s quirky, charming, and often heroic feline history.",
  },
  {
    question: "Where do the tours take place?",
    answer:
      "We currently prowl through the cat-tastic corners of Brooklyn and Manhattan.",
  },
  {
    question: "Who are the tour guides?",
    answer:
      "Our guides are cat lovers, local historians, and storytellers with a passion for NYC's hidden pawprints. You won’t just get facts—you’ll get feline folklore.",
  },
  {
    question: "How long are the tours?",
    answer: "Each tour runs about 2 hours, covering several stops and plenty of photo ops.",
  },
  {
    question: "How can I book a tour?",
    answer: "Easy—just head to www.catsabouttowntours.com to grab your spot.",
  },
];
